export const GET_DETAIL_EXPERIENCE_ITEMS = 'GET_DETAIL_EXPERIENCE_ITEMS';
